import { FC, SVGProps } from "react";
import clsx from "clsx";

// ----------------------------------------------------------------------------------

export type IWhatsappProps = SVGProps<SVGSVGElement> & {
  variant: "white" | "black" | "normal";
};

const Whatsapp: FC<IWhatsappProps> = (props) => {
  const { variant, className, ...other } = props;

  return (
    <>
      {variant === "white" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 31 29"
          fill="none"
          className={clsx("rounded-sm bg-white p-[2px]", className)}
          xmlns="http://www.w3.org/2000/svg"
          {...other}
        >
          <g clipPath="url(#clip0_1304_6776)">
            <path
              d="M8.96685 23.9651L9.40839 24.2276C11.2629 25.3319 13.3892 25.9161 15.5576 25.9171H15.5621C22.2212 25.9171 27.6407 20.4804 27.6434 13.7982C27.6446 10.5601 26.3891 7.51502 24.1081 5.22445C22.9893 4.09481 21.6584 3.19904 20.1923 2.58902C18.7262 1.97899 17.154 1.66681 15.5669 1.67055C8.90264 1.67055 3.48303 7.10666 3.48066 13.7885C3.47737 16.0701 4.11771 18.3061 5.32763 20.2379L5.61508 20.6963L4.39436 25.168L8.96685 23.9651ZM0.904297 28.6323L2.96661 21.0769C1.69473 18.8658 1.0256 16.3574 1.02639 13.7875C1.02975 5.74798 7.54996 -0.79248 15.5623 -0.79248C19.4505 -0.790498 23.1 0.72776 25.8447 3.48378C28.5893 6.2398 30.0995 9.90312 30.0981 13.7992C30.0945 21.8381 23.5733 28.3797 15.5621 28.3797H15.5558C13.1233 28.3787 10.733 27.7664 8.60986 26.6048L0.904297 28.6323Z"
              fill="#B3B3B3"
            />
            <path
              d="M0.753906 28.4824L2.81622 20.927C1.54215 18.7105 0.872919 16.1963 0.875997 13.6376C0.879356 5.59808 7.39957 -0.942383 15.4119 -0.942383C19.3001 -0.9404 22.9496 0.577858 25.6943 3.33388C28.4389 6.08989 29.9491 9.75322 29.9477 13.6493C29.9441 21.6882 23.4229 28.2298 15.4117 28.2298H15.4054C12.9729 28.2288 10.5826 27.6165 8.45947 26.4548L0.753906 28.4824Z"
              fill="white"
            />
            <path
              d="M15.4163 1.52079C8.75208 1.52079 3.33246 6.9569 3.33009 13.6387C3.32681 15.9203 3.96714 18.1563 5.17706 20.0882L5.46451 20.5467L4.2438 25.0184L8.81648 23.8153L9.25803 24.0778C11.1125 25.1821 13.2388 25.7661 15.4072 25.7673H15.4118C22.0709 25.7673 27.4905 20.3306 27.4931 13.6484C27.4981 12.0557 27.1882 10.4779 26.5814 9.00619C25.9745 7.5345 25.0828 6.19821 23.9578 5.07469C22.839 3.94502 21.508 3.04924 20.0418 2.43921C18.5757 1.82918 17.0035 1.51702 15.4163 1.52079Z"
              fill="#054ADA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7786 7.54265C11.5064 6.93586 11.2199 6.92357 10.9613 6.91306L10.2651 6.90454C10.0229 6.90454 9.62937 6.99573 9.29668 7.36047C8.96399 7.72522 8.02539 8.60676 8.02539 10.3998C8.02539 12.1928 9.32691 13.9253 9.50826 14.1687C9.68962 14.4122 12.0208 18.2089 15.7126 19.6697C18.7805 20.8837 19.4048 20.6422 20.0709 20.5815C20.7371 20.5209 22.2198 19.7 22.5222 18.849C22.8247 17.998 22.8249 17.2689 22.7342 17.1165C22.6435 16.964 22.4013 16.8734 22.0378 16.691C21.6743 16.5087 19.889 15.6271 19.5561 15.5054C19.2232 15.3837 18.9812 15.3233 18.7388 15.688C18.4964 16.0527 17.8012 16.8732 17.5892 17.1165C17.3772 17.3597 17.1656 17.3902 16.8021 17.208C16.4386 17.0259 15.2691 16.6409 13.8814 15.3994C12.8018 14.4334 12.073 13.2404 11.8608 12.8759C11.6486 12.5113 11.8383 12.3139 12.0204 12.1323C12.1834 11.969 12.3835 11.7067 12.5655 11.494C12.7474 11.2813 12.8073 11.1293 12.9282 10.8864C13.0491 10.6436 12.9888 10.4303 12.898 10.2481C12.8071 10.0659 12.1014 8.26342 11.7786 7.54265Z"
              fill="white"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1304_6776"
              x1="15.1656"
              y1="2.97581"
              x2="15.2889"
              y2="23.696"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#949494" />
              <stop offset="1" stop-color="#6B6B6B" />
            </linearGradient>
            <clipPath id="clip0_1304_6776">
              <rect
                width="30"
                height="29"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}

      {variant === "black" && (
        <svg
          width="25"
          height="25"
          viewBox="0 0 31 29"
          fill="none"
          className={clsx("rounded-sm bg-black-900 p-[2px]", className)}
          xmlns="http://www.w3.org/2000/svg"
          {...other}
        >
          <g clipPath="url(#clip0_1304_6776)">
            <path
              d="M8.96685 23.9651L9.40839 24.2276C11.2629 25.3319 13.3892 25.9161 15.5576 25.9171H15.5621C22.2212 25.9171 27.6407 20.4804 27.6434 13.7982C27.6446 10.5601 26.3891 7.51502 24.1081 5.22445C22.9893 4.09481 21.6584 3.19904 20.1923 2.58902C18.7262 1.97899 17.154 1.66681 15.5669 1.67055C8.90264 1.67055 3.48303 7.10666 3.48066 13.7885C3.47737 16.0701 4.11771 18.3061 5.32763 20.2379L5.61508 20.6963L4.39436 25.168L8.96685 23.9651ZM0.904297 28.6323L2.96661 21.0769C1.69473 18.8658 1.0256 16.3574 1.02639 13.7875C1.02975 5.74798 7.54996 -0.79248 15.5623 -0.79248C19.4505 -0.790498 23.1 0.72776 25.8447 3.48378C28.5893 6.2398 30.0995 9.90312 30.0981 13.7992C30.0945 21.8381 23.5733 28.3797 15.5621 28.3797H15.5558C13.1233 28.3787 10.733 27.7664 8.60986 26.6048L0.904297 28.6323Z"
              fill="#252C37"
            />
            <path
              d="M0.753906 28.4824L2.81622 20.927C1.54215 18.7105 0.872919 16.1963 0.875997 13.6376C0.879356 5.59808 7.39957 -0.942383 15.4119 -0.942383C19.3001 -0.9404 22.9496 0.577858 25.6943 3.33388C28.4389 6.08989 29.9491 9.75322 29.9477 13.6493C29.9441 21.6882 23.4229 28.2298 15.4117 28.2298H15.4054C12.9729 28.2288 10.5826 27.6165 8.45947 26.4548L0.753906 28.4824Z"
              fill="#252C37"
            />
            <path
              d="M15.4163 1.52079C8.75208 1.52079 3.33246 6.9569 3.33009 13.6387C3.32681 15.9203 3.96714 18.1563 5.17706 20.0882L5.46451 20.5467L4.2438 25.0184L8.81648 23.8153L9.25803 24.0778C11.1125 25.1821 13.2388 25.7661 15.4072 25.7673H15.4118C22.0709 25.7673 27.4905 20.3306 27.4931 13.6484C27.4981 12.0557 27.1882 10.4779 26.5814 9.00619C25.9745 7.5345 25.0828 6.19821 23.9578 5.07469C22.839 3.94502 21.508 3.04924 20.0418 2.43921C18.5757 1.82918 17.0035 1.51702 15.4163 1.52079Z"
              fill="#EFFBFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7786 7.54265C11.5064 6.93586 11.2199 6.92357 10.9613 6.91306L10.2651 6.90454C10.0229 6.90454 9.62937 6.99573 9.29668 7.36047C8.96399 7.72522 8.02539 8.60676 8.02539 10.3998C8.02539 12.1928 9.32691 13.9253 9.50826 14.1687C9.68962 14.4122 12.0208 18.2089 15.7126 19.6697C18.7805 20.8837 19.4048 20.6422 20.0709 20.5815C20.7371 20.5209 22.2198 19.7 22.5222 18.849C22.8247 17.998 22.8249 17.2689 22.7342 17.1165C22.6435 16.964 22.4013 16.8734 22.0378 16.691C21.6743 16.5087 19.889 15.6271 19.5561 15.5054C19.2232 15.3837 18.9812 15.3233 18.7388 15.688C18.4964 16.0527 17.8012 16.8732 17.5892 17.1165C17.3772 17.3597 17.1656 17.3902 16.8021 17.208C16.4386 17.0259 15.2691 16.6409 13.8814 15.3994C12.8018 14.4334 12.073 13.2404 11.8608 12.8759C11.6486 12.5113 11.8383 12.3139 12.0204 12.1323C12.1834 11.969 12.3835 11.7067 12.5655 11.494C12.7474 11.2813 12.8073 11.1293 12.9282 10.8864C13.0491 10.6436 12.9888 10.4303 12.898 10.2481C12.8071 10.0659 12.1014 8.26342 11.7786 7.54265Z"
              fill="#252C37"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1304_6776"
              x1="15.1656"
              y1="2.97581"
              x2="15.2889"
              y2="23.696"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#949494" />
              <stop offset="1" stop-color="#6B6B6B" />
            </linearGradient>
            <clipPath id="clip0_1304_6776">
              <rect
                width="30"
                height="29"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}

      {variant === "normal" && (
        <svg
          width="31"
          height="29"
          viewBox="0 0 31 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...other}
        >
          <g clipPath="url(#clip0_1304_6776)">
            <path
              d="M8.96685 23.9651L9.40839 24.2276C11.2629 25.3319 13.3892 25.9161 15.5576 25.9171H15.5621C22.2212 25.9171 27.6407 20.4804 27.6434 13.7982C27.6446 10.5601 26.3891 7.51502 24.1081 5.22445C22.9893 4.09481 21.6584 3.19904 20.1923 2.58902C18.7262 1.97899 17.154 1.66681 15.5669 1.67055C8.90264 1.67055 3.48303 7.10666 3.48066 13.7885C3.47737 16.0701 4.11771 18.3061 5.32763 20.2379L5.61508 20.6963L4.39436 25.168L8.96685 23.9651ZM0.904297 28.6323L2.96661 21.0769C1.69473 18.8658 1.0256 16.3574 1.02639 13.7875C1.02975 5.74798 7.54996 -0.79248 15.5623 -0.79248C19.4505 -0.790498 23.1 0.72776 25.8447 3.48378C28.5893 6.2398 30.0995 9.90312 30.0981 13.7992C30.0945 21.8381 23.5733 28.3797 15.5621 28.3797H15.5558C13.1233 28.3787 10.733 27.7664 8.60986 26.6048L0.904297 28.6323Z"
              fill="#B3B3B3"
            />
            <path
              d="M0.753906 28.4824L2.81622 20.927C1.54215 18.7105 0.872919 16.1963 0.875997 13.6376C0.879356 5.59808 7.39957 -0.942383 15.4119 -0.942383C19.3001 -0.9404 22.9496 0.577858 25.6943 3.33388C28.4389 6.08989 29.9491 9.75322 29.9477 13.6493C29.9441 21.6882 23.4229 28.2298 15.4117 28.2298H15.4054C12.9729 28.2288 10.5826 27.6165 8.45947 26.4548L0.753906 28.4824Z"
              fill="white"
            />
            <path
              d="M15.4163 1.52079C8.75208 1.52079 3.33246 6.9569 3.33009 13.6387C3.32681 15.9203 3.96714 18.1563 5.17706 20.0882L5.46451 20.5467L4.2438 25.0184L8.81648 23.8153L9.25803 24.0778C11.1125 25.1821 13.2388 25.7661 15.4072 25.7673H15.4118C22.0709 25.7673 27.4905 20.3306 27.4931 13.6484C27.4981 12.0557 27.1882 10.4779 26.5814 9.00619C25.9745 7.5345 25.0828 6.19821 23.9578 5.07469C22.839 3.94502 21.508 3.04924 20.0418 2.43921C18.5757 1.82918 17.0035 1.51702 15.4163 1.52079Z"
              fill="url(#paint0_linear_1304_6776)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7786 7.54265C11.5064 6.93586 11.2199 6.92357 10.9613 6.91306L10.2651 6.90454C10.0229 6.90454 9.62937 6.99573 9.29668 7.36047C8.96399 7.72522 8.02539 8.60676 8.02539 10.3998C8.02539 12.1928 9.32691 13.9253 9.50826 14.1687C9.68962 14.4122 12.0208 18.2089 15.7126 19.6697C18.7805 20.8837 19.4048 20.6422 20.0709 20.5815C20.7371 20.5209 22.2198 19.7 22.5222 18.849C22.8247 17.998 22.8249 17.2689 22.7342 17.1165C22.6435 16.964 22.4013 16.8734 22.0378 16.691C21.6743 16.5087 19.889 15.6271 19.5561 15.5054C19.2232 15.3837 18.9812 15.3233 18.7388 15.688C18.4964 16.0527 17.8012 16.8732 17.5892 17.1165C17.3772 17.3597 17.1656 17.3902 16.8021 17.208C16.4386 17.0259 15.2691 16.6409 13.8814 15.3994C12.8018 14.4334 12.073 13.2404 11.8608 12.8759C11.6486 12.5113 11.8383 12.3139 12.0204 12.1323C12.1834 11.969 12.3835 11.7067 12.5655 11.494C12.7474 11.2813 12.8073 11.1293 12.9282 10.8864C13.0491 10.6436 12.9888 10.4303 12.898 10.2481C12.8071 10.0659 12.1014 8.26342 11.7786 7.54265Z"
              fill="white"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1304_6776"
              x1="15.1656"
              y1="2.97581"
              x2="15.2889"
              y2="23.696"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#949494" />
              <stop offset="1" stop-color="#6B6B6B" />
            </linearGradient>
            <clipPath id="clip0_1304_6776">
              <rect
                width="30"
                height="29"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default Whatsapp;
